export default __webpack_public_path__ + "static/media/gallery-12-3.ef4ccf36.webp";